import { Phone, Mail, MapPin, Building2, Hash, FileBadge, ShieldCheck } from "lucide-react";
import { CONTACT } from "@/content";

const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CONTACT.mapsQuery)}`;

export const contactItems = () => [
  ...CONTACT.phones.map((p, i) => ({ icon: Phone, value: p.label, href: p.href, id: `phone-${i + 1}`, kind: "phone" })),
  ...CONTACT.emails.map((e) => ({ icon: Mail, value: e, href: `mailto:${e}`, id: `email-${e.split("@")[0]}`, kind: "email" })),
  { icon: MapPin, value: CONTACT.address, href: mapsUrl, id: "address", kind: "address" },
];

export const companyItems = (f) => [
  { icon: Building2, label: f.company, value: CONTACT.company, id: "company" },
  { icon: ShieldCheck, label: f.license, value: CONTACT.license, id: "license" },
  { icon: Hash, label: "CUI", value: CONTACT.cui, id: "cui" },
  { icon: FileBadge, label: "Reg. Com.", value: CONTACT.regcom, id: "regcom" },
];

export const IconLine = ({ icon: Icon, children, href, testId }) => {
  const inner = (
    <>
      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center border border-red-700/50 bg-red-950/40">
        <Icon className="h-3.5 w-3.5 text-red-500" strokeWidth={1.75} />
      </span>
      <span className="min-w-0 break-words">{children}</span>
    </>
  );
  const cls = "flex items-start gap-3 text-sm text-zinc-200";
  if (!href) return <div className={cls} data-testid={testId}>{inner}</div>;
  return (
    <a href={href} data-testid={testId} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className={`${cls} hover:text-white group`}>
      {inner}
    </a>
  );
};
